namespace $ { export class $mol_row extends $mol_view {

} }
